import { render, staticRenderFns } from "./[slug].vue?vue&type=template&id=5dd0a0d4&scoped=true"
import script from "./[slug].vue?vue&type=script&lang=js"
export * from "./[slug].vue?vue&type=script&lang=js"
import style0 from "./[slug].vue?vue&type=style&index=0&id=5dd0a0d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd0a0d4",
  null
  
)

export default component.exports